import RestService from '../services/rest';

async function getAllTypeCoating(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/TypeCoating/all?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getTypeCoatingOptions(search) {
  return RestService.getAuthenticated(
    `panel/TypeCoating/options?search=${search}`,
  );
}

async function createTypeCoating(newTypeCoating) {
  return RestService.postAuthenticated(
    'panel/TypeCoating/create', newTypeCoating,
  );
}

async function updateTypeCoating(updTypeCoating) {
  return RestService.putAuthenticated(
    'panel/TypeCoating/update', updTypeCoating,
  );
}

export default {
  getAllTypeCoating,
  getTypeCoatingOptions,
  createTypeCoating,
  updateTypeCoating,
};
